// src/app/login.guard.ts
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Login Guard - Prevents logged-in users from accessing the login page
 * Redirects to public-schedule if already authenticated
 */
export const loginGuard = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // If user is already logged in, redirect to public-schedule
  if (auth.isLoggedIn) {
    router.navigate(['/public-schedule']);
    return false;
  }

  // Allow access to login page if not logged in
  return true;
};